<script setup lang="ts">
import type { StoryblokMaybeLivePreview } from '#shared/types/storyblok.type';

export interface StoryblokLegalPageProps {
    blok: StoryblokMaybeLivePreview<StoryblokLegalPage>;
}
// PROPS
const { blok } = defineProps<StoryblokLegalPageProps>();
</script>

<template>
    <BasePage v-editable="blok">
        <BasePageTitle v-if="blok.title" :title="blok.title" :sub-title="blok.subtitle" />
        <BaseVerticalStack as="section">
            <StoryblokRichTextOverride v-if="!!blok.content" class="prose-a:text-primary prose-a:font-normal max-w-none" :doc="blok.content" />
            <template v-if="blok.vexatiousClauses">
                <USeparator label="*********" />
                <p class="text-toned text-sm/6">{{ blok.vexatiousClauses }}</p>
            </template>
        </BaseVerticalStack>
    </BasePage>
</template>
